// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.metrics-grid {
  padding: var(--spacing-lg);
  height: 100%;
}

.metrics-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-lg);
}

.card-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
}

.metrics-subtitle {
  font-size: 0.8rem;
  color: var(--text-muted);
}

.metrics-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--spacing-md);
}

.metric-card {
  background: var(--bg-secondary);
  border-radius: var(--radius-md);
  padding: var(--spacing-md);
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  position: relative;
  border: 1px solid var(--border-color);
  transition: all var(--transition-fast);
}

.metric-card:hover {
  background: var(--bg-card-hover);
  transform: translateY(-2px);
}

.metric-card.warning {
  border-color: var(--accent-yellow);
  background: rgba(245, 158, 11, 0.1);
}

.metric-icon {
  font-size: 1.5rem;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-card);
  border-radius: var(--radius-sm);
}

.metric-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.metric-label {
  font-size: 0.75rem;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.metric-value {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
}

.metric-sub-value {
  font-size: 0.65rem;
  color: var(--text-muted);
  margin-top: -2px;
}

.metric-description {
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.metric-status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: absolute;
  top: 12px;
  right: 12px;
}

.metric-status-indicator.normal {
  background: var(--accent-green);
}

.metric-status-indicator.warning {
  background: var(--accent-yellow);
  animation: pulse 1.5s infinite;
}

@media (max-width: 1200px) {
  .metrics-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .metrics-container {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MetricsGrid/MetricsGrid.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".metrics-grid {\n  padding: var(--spacing-lg);\n  height: 100%;\n}\n\n.metrics-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--spacing-lg);\n}\n\n.card-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.metrics-subtitle {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n}\n\n.metrics-container {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: var(--spacing-md);\n}\n\n.metric-card {\n  background: var(--bg-secondary);\n  border-radius: var(--radius-md);\n  padding: var(--spacing-md);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  position: relative;\n  border: 1px solid var(--border-color);\n  transition: all var(--transition-fast);\n}\n\n.metric-card:hover {\n  background: var(--bg-card-hover);\n  transform: translateY(-2px);\n}\n\n.metric-card.warning {\n  border-color: var(--accent-yellow);\n  background: rgba(245, 158, 11, 0.1);\n}\n\n.metric-icon {\n  font-size: 1.5rem;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-card);\n  border-radius: var(--radius-sm);\n}\n\n.metric-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.metric-label {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.metric-value {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.metric-sub-value {\n  font-size: 0.65rem;\n  color: var(--text-muted);\n  margin-top: -2px;\n}\n\n.metric-description {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n.metric-status-indicator {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  position: absolute;\n  top: 12px;\n  right: 12px;\n}\n\n.metric-status-indicator.normal {\n  background: var(--accent-green);\n}\n\n.metric-status-indicator.warning {\n  background: var(--accent-yellow);\n  animation: pulse 1.5s infinite;\n}\n\n@media (max-width: 1200px) {\n  .metrics-container {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 600px) {\n  .metrics-container {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
